import React, { useEffect, useRef } from "react";
import { LOCATION_DIVISION_DATA, PHONE_PLACEHOLDER, PROVINCEDRPDATA } from "../../../App.config";
import Compensation from "../../../images/Compensation.svg";
import DropdownComponent from "../../../containers/Dropdown";
import ApplicationFilter from "../../../containers/ApplicationFilter";

const EmployerInformation = ({
  onSubmit,
  handleChanges,
  state,
  props,
  handlePhoneNumber,
  onDropDownChange,
  onFilterDropDownChange,
  onFilterDrpChange
}) => {
  //Set focus on element after first render
  useEffect(() => {
    if (state.location.ref.current) {
      state.location.ref.current.focus();
    }
  }, []);

  // useEffect(() => {
  //   if (props.location && Array.isArray(props.location) && !props.location.some(x => x.locationName == "Other"))
  //     props.location.push({ locationName: "Other" })
  // }, [props.location]);

  return (
    <>
      <div className="Dashboard-Content">
        <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Panel-header">
              <div className="p-img">
                <img src={Compensation} alt="" />
              </div>
              <h2>
                <span>
                  {props.context.t(
                    "AIR-Employer-Information.form.heading.text"
                  )}
                </span>

              </h2>
              {/* <legend>EMPLOYER INFORMATION</legend> */}
            </div>
            {/* {props.profileReducer && props.profileReducer.companyServices && props.profileReducer.companyServices.hasDemographicFileFeature &&  */}
            <ApplicationFilter selectedFilterValue={state.selectedFilterValue}
              context={props.context}
              onFilterDropDownChange={onFilterDropDownChange} onFilterDrpChange={onFilterDrpChange} />
             {/* } */}

            <div className="panel-content">
              <div className="Custom-form">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employer-Information.form.label.text.CompanyName"
                        )}

                      </label>
                      <input
                        type="text"
                        name="companyName"
                        value={state.companyName.value}
                        ref={state.companyName.ref}
                        onChange={handleChanges}
                        className="form-control"
                        readOnly
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                      />
                    </div>

                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employer-Information.form.label.text.Location"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      {props.location && (
                        <DropdownComponent
                          name="location"
                          options={props.location}
                          isMultiSelect={false}
                          option_key="coLocationID_PK"
                          option_display="regionLocationText"
                          onChange={onDropDownChange}
                          values={state.location.value}
                          simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                          selectAllText="Select All Options"
                          isSearchOption={true}
                          searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          ref={state.location.ref}
                        />
                      )}
                    </div>
                    {state.location?.error && (
                      <span className="error">{state.location.error}</span>
                    )}
                  </div>
                  {/* {state.location.value && state.location.value[0] == "Other" &&
                    <div className="col-12 col-sm-12 col-md-12 col-lg">
                      <div className="form-group">
                        <label htmlFor="">
                          {props.context.t(
                            "AIR-Employer-Information.form.label.text.OtherLocation"
                          )}
                          <span size="5" className="error-star">
                            *
                        </span>
                        </label>
                        <input
                          type="text"
                          name="otherLocation"
                          value={state.otherLocation.value}
                          ref={state.otherLocation.ref}
                          onChange={handleChanges}
                          className="form-control"
                          placeholder={props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          )}
                        />
                      </div>
                      {state.otherLocation?.error && (
                        <span className="error">{state.otherLocation.error}</span>
                      )}
                    </div>
                  } */}
                </div>
                {/* <div className="row">

                  <div className="col-12 col-sm-12 col-md-12 col-lg-auto">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employer-Information.form.label.text.checkOne"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="accFirm"
                            id="acc-check"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Account Number"
                            checked={state.accFirm.value === "Account Number"}
                          />
                          <label htmlFor="acc-check">
                            {props.context.t(
                              "AIR-Employer-Information.form.label.text.AccountNo"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="accFirm"
                            id="firm-check"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Firm Number"
                            checked={state.accFirm.value === "Firm Number"}
                          />
                          <label htmlFor="firm-check">
                            {props.context.t(
                              "AIR-Employer-Information.form.label.text.FirmNo"
                            )}
                          </label>
                        </div>
                      </div>
                      {state.accFirm?.error && (
                        <span className="error">{state.accFirm.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employer-Information.form.label.text.WCBAccNo"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        name="wcbNo"
                        value={state.wcbNo.value}
                        ref={state.wcbNo.ref}
                        onChange={handleChanges}
                        className="form-control"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                      />
                      {state.wcbNo?.error && (
                        <span className="error">{state.wcbNo.error}</span>
                      )}
                    </div>
                  </div>
                </div> */}

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employer-Information.form.label.text.BusinessType"
                        )}
                      </label>
                      <input
                        type="text"
                        name="bussinessType"
                        value={state.bussinessType.value}
                        ref={state.bussinessType.ref}
                        onChange={handleChanges}
                        className="form-control"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                      />
                      {state.bussinessType?.error && (
                        <span className="error">
                          {state.bussinessType.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employer-Information.form.label.text.ClassificationUnit"
                        )}
                      </label>
                      <input
                        type="text"
                        name="classificationUnit"
                        value={state.classificationUnit.value}
                        ref={state.classificationUnit.ref}
                        onChange={handleChanges}
                        className="form-control"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                      />
                      {state.classificationUnit?.error && (
                        <span className="error">
                          {state.classificationUnit.error}
                        </span>
                      )}
                    </div>
                  </div>

                </div>
                {/* <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employer-Information.form.label.text.EmpContactName"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        name="employerContactName"
                        value={state.employerContactName.value}
                        ref={state.employerContactName.ref}
                        onChange={handleChanges}
                        className="form-control"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                      />
                      {state.employerContactName?.error && (
                        <span className="error">
                          {state.employerContactName.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employer-Information.form.label.text.Position"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        name="position"
                        value={state.position.value}
                        ref={state.position.ref}
                        onChange={handleChanges}
                        className="form-control"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                      />
                      {state.position?.error && (
                        <span className="error">{state.position.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Employer-Information.form.label.text.TelephoneNumber"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        name="telephone"
                        value={state.telephone.value}
                        ref={state.telephone.ref}
                        onChange={handlePhoneNumber}
                        className="form-control"
                        placeholder={PHONE_PLACEHOLDER}
                        maxLength="14"
                      />
                      {state.telephone?.error && (
                        <span className="error">{state.telephone.error}</span>
                      )}
                    </div>
                  </div>
                </div> */}

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="panel-footer text-right margn-50">
                      <a
                        tabIndex="0"
                        onClick={onSubmit}
                        className="btn btn-primary"
                      >
                        {props.context.t(
                          "AIR-Employer-Information.form.button.save-and-move-next-step.title"
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EmployerInformation;
